<template>
  <button class="navbar-toggler" type="button" v-b-toggle="toggleSidebar[0]" :data-toggle="toggleSidebar[1]" style="filter: invert(1);"
          data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
</template>

<script>
export default {
  name: "TogglerButton",
  props: ['toggleSidebar'],
}
</script>